import axios from 'axios';

export class AccountNotProvisionedError extends Error {
    constructor(userId) {
        super(`Account not provisioned for userId=${userId}`);
        this.name = 'AccountNotProvisionedError';
        this.category = 'ACCOUNT_NOT_PROVISIONED';
        this.userId = userId;
    }
}

export class AccountDeactivatedError extends Error {
    constructor(userId) {
        super(`Account deactivated for userId=${userId}`);
        this.name = 'AccountDeactivatedError';
        this.category = 'ACCOUNT_DEACTIVATED';
        this.userId = userId;
    }
}

export const CurrentUserInitializer = async (usersStore, adminStore, userId) => {
    try {
        await usersStore.loadCurrentUser(userId);

        if (usersStore.currentUser.isAdmin) {
            await adminStore.load();
        } else {
            await adminStore.loadEnterprise(userId);
        }

        // Detect and sync browser timezone to user record for timezone-aware emails
        try {
            const browserTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
            if (browserTimezone) {
                await axios.patch(`/users/${userId}`, { timezone: browserTimezone });
            }
        } catch (tzError) {
            console.warn('Failed to sync timezone:', tzError.message);
        }

    } catch (error) {
        const status = error?.response?.status;
        const msg = error?.response?.data?.error || error?.message || '';
        // Hardened backend responses this must classify: 404 (no record),
        // 401/403 "User account not found" (orphan JWT on gated routes), and
        // the release-1.9.0 deactivated-user 401 — without the last one, a
        // deactivated user landed on the generic INIT_FAILED screen.
        if (status === 404 || ((status === 401 || status === 403) && /User account not found/i.test(msg))) {
            console.error('CurrentUserInitializer: account not provisioned', { userId, status, msg });
            throw new AccountNotProvisionedError(userId);
        }
        if (status === 401 && /Account deactivated/i.test(msg)) {
            console.error('CurrentUserInitializer: account deactivated', { userId });
            throw new AccountDeactivatedError(userId);
        }
        throw error;
    }
};
